import React, { Fragment, useContext } from 'react';
import LocaleContext from 'constants/localization';
import { connect, useSelector } from 'react-redux';
import { SET_CHECKED_URIS } from 'constants/actionTypes';

const ResultSelect = ({object, selectable, updateCheckedUris}) => {
  const LS = useContext(LocaleContext);
  const checkedUris = useSelector(state => state.modal.checkedUris);

  return (
    <Fragment>
      {
        selectable &&
        <input 
          id='searchResultSelect'
          name="selectedIds"
          type="checkbox"
          value={object.uri}
          onChange={() => updateCheckedUris(object.uri, checkedUris)}
        />
      }
      {
        object.isDeleted && <span style={{color: 'red'}}>{LS.deleted}</span>
      }
    </Fragment>
  );
};

const updateCheckedUris = (uri, checkedUris) => dispatch => {
  let updatedUris = [];
  if (checkedUris.includes(uri)) {
    updatedUris = checkedUris.filter(oldUri => oldUri != uri);
  } else {
    updatedUris = checkedUris.concat(uri);
  }
  dispatch({type: SET_CHECKED_URIS, updatedUris});
};

export default connect(null, { updateCheckedUris }) (ResultSelect);